<div class="lib-login-container d-flex fd-col jc-center ai-stretch">
  <div
    class="icons-container adjustIconsToText flex-1 d-flex fd-row jc-start ai-center"
  >
    <span class="material-icons border-circle">construction</span>
    <span class="material-icons border-circle">train</span>
    <span class="material-icons border-circle">cases</span>
  </div>
  <span class="login-title">{{ loginComponentOptions.titleText }}</span>
  <lib-login
    #login
    [loginComponentOptions]="loginComponentOptions"
    (loginStatusChange)="onLoginStatusChange($event)"
    (resetPasswordStatusChange)="onResetPasswordStatusChange($event)"
  ></lib-login>

  <ng-container *ngIf="mode == 'login'">
    <mat-divider class="signup-divider"></mat-divider>
    <p>
      Take advantage of our aggregated data and global railway data platform.
      <b class="highlight"
        >Free for the first {{ freeTrial === 1 ? '1 day' : freeTrial + ' days' }}.</b
      >
    </p>
    <button class="signup-button" mat-flat-button (click)="login.goToRegister()">Sign up</button>

    <!-- <button mat-raised-button color="accent" routerLink="/register" class="register-button">
      <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd">
        <path
          d="M11.5 0c6.347 0 11.5 5.153 11.5 11.5s-5.153 11.5-11.5 11.5-11.5-5.153-11.5-11.5 5.153-11.5 11.5-11.5zm0 1c5.795 0 10.5 4.705 10.5 10.5s-4.705 10.5-10.5 10.5-10.5-4.705-10.5-10.5 4.705-10.5 10.5-10.5zm.5 10h6v1h-6v6h-1v-6h-6v-1h6v-6h1v6z" />
      </svg> Signup for a Free Trial
    </button> -->
  </ng-container>

  <div
    *ngIf="loginStatus == 'LOGIN_ATTEMPT_PENDING'"
    class="logging-in-overlay d-flex fd-col jc-center ai-center"
  >
    <span class="login-status-message">Logging in</span>
    <br />
    <mat-spinner></mat-spinner>
  </div>

  <div
    *ngIf="passwordResetStatus == 'PASSWORD_RESET_ATTEMPT_COMPLETE'"
    class="back-to-login-container d-flex fd-row jc-center ai-center"
  >
    <button color="primary" mat-stroked-button routerLink="/identity">Back to Login</button>
  </div>
</div>
